import React from 'react'
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const TermsConditions = () => {
	const allPagesContent = useSelector((state) => state.pages.pages)
    const TermsContent = allPagesContent.find((page) => page.slug === 'terms-and-conditions')
	const isPageLoading = useSelector((state) => state.pages.isLoading)
	return (
		isPageLoading ?
			<div className='spinner-wrapper'> 
				<Spinner animation="border" variant="info" />
			</div>
		:
		<div className='main-text-section'>
			<Container>
				<Row>
					<Col>
						<h2>Terms & Conditions</h2>
						<div dangerouslySetInnerHTML={{ __html: TermsContent?.content?.rendered }}></div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

export default TermsConditions